/*
 * @Description: 
 * @Author: beiweiping
 * @Date: 2019-06-25 08:59:58
 * @LastEditTime: 2021-04-14 21:34:34
 * @LastEditors: chenzel
 */
/**
 * Created by zhanghuan on 2016/12/15.
 * 公共方法类
 */
import axios from 'axios'

const AJAX = axios.create({
  baseURL: `//${globalConfig.linkBasePath}`,
  withCredentials: true
})

function YunJi() {

}
let currentAjax = null // 当前请求的ajax

YunJi.prototype = {
  appUA: '', // app传过来的UserAgent,
  // basePath:"//t.yunjiweidian.com/yunjibuyer",
  basePath: `//${window.location.host}/yunjibuyer`,
  weixinInfo: { // 微信分享相关的信息
    title: '',
    desc: '',
    imgUrl: '',
    shareLink: ''
  },
  markOrderArray: [],
  /**
   * rem单位计算
   * 设计稿是宽750，当一个div的宽是30px，转换rem为：30px/100px = 0.3rem
   * 设计稿是宽375，当一个div的宽是30px，转换rem为：30px*2/100px = 0.6rem
   */
  initRem: function () {
    const appUA = navigator.userAgent // app的UserAgent信息
    if (appUA && appUA.indexOf('{"appVersion') != -1) {
      YunJi.appUA = JSON.parse(appUA.substring(appUA.indexOf('{')))
    }

    /* rem控制不同屏幕显示大小 */
    YunJi.windowSize(document, window)
    window.onresize = function () {
      YunJi.windowSize(document, window)
    }
  },
  /**
   * 计算html字体font-size大小
   * @param doc document对象
   * @param win window对象
   */
  windowSize: function (doc, win) {
    var docEl = doc.documentElement,
      isIOS = navigator.userAgent.match(/iphone|ipod|ipad/gi),
      dpr = isIOS ? Math.min(win.devicePixelRatio, 3) : 1,
      dpr = window.top === window.self ? dpr : 1, // 被iframe引用时，禁止缩放
      dpr = 1, // 首页引用IFRAME，强制为1
      scale = 1 / dpr,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
    docEl.dataset.dpr = win.devicePixelRatio
    if (navigator.userAgent.match(/iphone/gi) && screen.width == 375 && win.devicePixelRatio == 2) {
      docEl.classList.add('iphone6')
      // scale = 0.5;
    }
    if (navigator.userAgent.match(/iphone/gi) && screen.width == 414 && win.devicePixelRatio == 3) {
      docEl.classList.add('iphone6p')
      // scale = 0.3333333333333333;
    }
    const metaEl = doc.createElement('meta')
    metaEl.name = 'viewport'
    metaEl.content = `initial-scale=${scale},maximum-scale=${scale}, minimum-scale=${scale}`
    docEl.firstElementChild.appendChild(metaEl)
    // deviceWidth通过document.documentElement.clientWidth就能取到
    const recalc = function () {
      let width = window.innerWidth
      if (width / dpr > 750) {
        width = 750 * dpr
      }
      docEl.style.fontSize = `${100 * (width / 750)}px`
    }
    recalc()
    if (!doc.addEventListener) return
  },
  isWxProgram: function () {
    return navigator.userAgent.indexOf(/miniprogram/i) > -1 || window.__wxjs_environment === 'miniprogram'
  },
  appUa() {
    var _appUA = navigator.userAgent //app的UserAgent信息
    if (_appUA && _appUA.indexOf('{"appVersion') != -1) {
      return JSON.parse(_appUA.substring(_appUA.indexOf('{')))
    }   
    return {} 
  },
  getAppIdForH5() {
    const ua = this.appUa()
    if (ua.appIdForH5) return ua.appIdForH5
    return ''
  },
  useWxMini: function(cb,load){
    if (window.wx && window.wx.miniProgram) {
      if(!load){
        cb && cb()
      }else{
        //加载就要执行的逻辑
        wx.miniProgram.getEnv((res)=> {
          if(res.miniprogram){
            cb && cb()
          }
        })
      }
      return
    }
    let oHead = document.getElementsByTagName('HEAD').item(0)
    let oScript = document.createElement("script")
    oScript.type = "text/javascript"
    oScript.onload = ()=>{
      if(!load){
        cb && cb()
      }else{
        wx.miniProgram && wx.miniProgram.getEnv((res)=> {
          if(res.miniprogram){
            cb && cb()
          }
        })
      }
    }
    // oScript.src ="//static.yunjiglobal.com/vue-buyer/index/js/jweixin-1.3.2.js"
    oScript.src = '//res.wx.qq.com/open/js/jweixin-1.6.0.js'
    oHead.appendChild(oScript)
  },
  /**
   * rem转成px
   */
  remToPx: function (remNum) {
    const rootFontSize = Number.parseFloat(document.documentElement.style.fontSize)
    return remNum * rootFontSize
  },
  /**
   * 获取url参数
   * @param param 参数名
   * @returns {*}
   */
  getUrlParams: function (param) {
    const ps = decodeURI(location.href)
    if (ps == '') return ''
    const params = (ps.substr(ps.lastIndexOf('?') + 1)).split('&')
    if (params != null) {
      for (let i = 0; i < params.length; i++) {
        const strs = params[i].split('=')
        if (strs[0] == param && strs[1]) {
          return strs[1]
        }
      }
    }
    return ''
  },
  /**
   * 获取url参数
   * @param url   用来获取参数的链接
   * @param param 参数名
   * @returns {*}
   */
  getRedirectUrlParams: function (url, param) {
    const ps = decodeURI(url)
    if (ps == '') return ''
    const params = (ps.substr(ps.lastIndexOf('?') + 1)).split('&')
    if (params != null) {
      for (let i = 0; i < params.length; i++) {
        const strs = params[i].split('=')
        if (strs[0] == param && strs[1]) {
          return strs[1]
        }
      }
    }
    return ''
  },
  /**
   * 设备类型
   */
  getPhoneType() {
    let result = false
    const u = navigator.userAgent
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
      result = false
    } else if (u.indexOf('iPhone') > -1) { // 苹果手机
      result = true
    } else if (u.indexOf('Windows Phone') > -1) { // winphone手机
      result = false
    } else if (u.indexOf('iPhone Simulator') > -1) {
      result = true
    }
    return result
  },
  /**
   * 是否是ipx
   */
  isIphoneX() {
    return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
  },
  /**
   * 获取倒计时
   * @param t 毫秒数的时间戳
   * @param fmt 转换的时间格式 “dd hh:mm:ss”或者”dd hh:mm“
   * @returns {string}
   */
  getSurplus: function (t, fmt) {
    var fmt = fmt || 'dd hh:mm:ss'
    let d = 0, 
      h = 0, 
      m = 0, 
      s = 0, 
      str = ''
    if (t >= 0) {
      d = Math.floor(t / 1000 / 60 / 60 / 24)
      h = Math.floor(t / 1000 / 60 / 60 % 24)
      m = Math.floor(t / 1000 / 60 % 60)
      s = Math.floor(t / 1000 % 60)
    }
    switch (fmt) {
      case 'hh:mm:ss':
        h = d * 24 + h
        if (h > 0) {
          str = `${this.parseDate(h)}:`
        }
        str = `${str + this.parseDate(m)}:${this.parseDate(s)}`
        break
      case 'dd hh:mm:ss': // 天 时分秒
        str += `${d}天${this.parseDate(h)}时${this.parseDate(m)}分${this.parseDate(s)}秒`
        break
      case 'd hh:mm:ss':
        str += `${this.parseDate(d)}天${this.parseDate(h)}时${this.parseDate(m)}分${this.parseDate(s)}秒`
        break
      case 'dd hh:mm:ss n': // 天 时分秒
        str += this.showNewStr(d, h, m, s)
        break
      case 'dd hh:mm:ss m': // 天 时分秒 (倒计时长大于24小时，展示天/时/分/秒，倒计时小于等于24小时，展示时/分/秒)
        str += this.showNewS(d, h, m, s)
        break
      case 'd h:m:s': // 天 时:分:秒
        str += `${d}:${this.parseDate(h)}:${this.parseDate(m)}:${this.parseDate(s)}`
        break
      case 'dd hh:mm': // 天 时分
        str += `${d}天${this.parseDate(h)}时${this.parseDate(m)}分`
        break
      case 'h:m': // 时:分
        str += `${this.parseDate(h)}:${this.parseDate(m)}`
        break
      case 'dd h:m:s': // 剩天时分秒
        str += this.showStr(d, h, m, s)
        break
      case 'h:m:s': // 剩时分秒
        str += this.showStr(d, h, m, s)
        break
      case 'mm:ss': // 还剩 分秒
        str += this.showStr(d, h, m, s)
        break
      case 'm:s': // 分秒
        if (m == 0) {
          if (s == 0) {
            str += ''
          } else {
            str += `00:${this.parseDate(s)}`
          }
        } else {
          str += `${this.parseDate(m)}:${this.parseDate(s)}`
        }
        break
      case 'm:s n': // 分秒
        if (m == 0) {
          if (s == 0) {
            str += ''
          } else {
            str += `0分${this.parseDate(s)}秒`
          }
        } else {
          str += `${this.parseDate(m)}分${this.parseDate(s)}秒`
        }
        break
      case 'hh':
        var hours = d * 24
        str += (hours + parseInt(this.parseDate(h)))
        break
      case 'mm':
        str += this.parseDate(m)
        break
      case 'ss':
        str += this.parseDate(s)
        break
    }
    return str
  },
  showStr: function (d, h, m, s) {
    const dStr = d > 0 ? `<span class='time'>${this.parseDate(d)}</span><i>天</i>` : ''
    const hStr = d > 0 && h >= 0 || (d <= 0 && h > 0) ? `<span class='time'>${this.parseDate(h)}</span><i>时</i>` : ''
    const mStr = m > 0 ? `<span class='time'>${this.parseDate(m)}</span><i>分</i>` : ''
    const sStr = `<span class='time'>${this.parseDate(s)}</span><i>秒</i>`
    const str = m == 0 && s == 0 ? '' : `（剩${dStr}${hStr}${mStr}${sStr}）`
    return str
  },
  showNewStr: function (d, h, m, s) {
    const dStr = d > 0 ? `${this.parseDate(d)}<span class='send-back-interval'>天</span>` : ''
    const hStr = d > 0 && h >= 0 || (d <= 0 && h > 0) ? `${this.parseDate(h)}<span class='send-back-interval'>时</span>` : ''
    const mStr = m > 0 ? `${this.parseDate(m)}<span class='send-back-interval'>分</span>` : ''
    const sStr = `${this.parseDate(s)}<span class='send-back-interval'>秒</span>`
    const str = m == 0 && s == 0 ? '' : dStr + hStr + mStr + sStr
    return str
  },
  showNewS: function (d, h, m, s) {
    const dStr = d > 0 ? `${this.parseDate(d)}<span class='send-back-interval'>天</span>` : ''
    const hStr = `${this.parseDate(h)}<span class='send-back-interval'>时</span>`
    const mStr = `${this.parseDate(m)}<span class='send-back-interval'>分</span>`
    const sStr = `${this.parseDate(s)}<span class='send-back-interval'>秒</span>`
    const str = dStr + hStr + mStr + sStr
    return str
  },
  /**
   * 转换日期格式
   * @param t 毫秒数的时间戳
   * @returns {string}
   */
  getLimitTime: function (t) {
    let month = 0, 
      d = 0, 
      h = 0, 
      m = 0, 
      str = ''
    const newTime = new Date(t)
    month = newTime.getMonth() + 1
    d = newTime.getDate()
    h = newTime.getHours()
    m = newTime.getMinutes()
    str += `${month}月${d}日  ${this.parseDate(h)}:${this.parseDate(m)}`
    return str
  },
  /**
   * 倒计时用
   * @param t 毫秒数的时间戳
   * @param fmt 转换的时间格式 “dd hh:mm:ss”或者”dd hh:mm“
   * @param callback 回调函数，每秒返回倒计时的时间
   */
  getIntervalTime: function (t, fmt, callback) {
    let timer = -1
    timer = setInterval(() => {
      t -= 1000
      if (callback) {
        callback(YunJi.getSurplus(t, fmt), timer)
      }
      if (t <= 0) {
        clearInterval(timer)
      }
    }, 1000)
  },
  /**
   * 判断是否css3中的Sticky属性
   * @returns {boolean}
   */
  isSupportSticky: function () {
    const prefixTestList = ['', '-webkit-', '-ms-', '-moz-', '-o-']
    let stickyText = ''
    for (let i = 0; i < prefixTestList.length; i++) {
      stickyText += `position:${prefixTestList[i]}sticky;`
    }
    // 创建一个dom来检查
    let div = document.createElement('div')
    const body = document.body
    div.style.cssText = `display:none;${stickyText}`
    body.appendChild(div)
    const isSupport = /sticky/i.test(window.getComputedStyle(div).position)
    body.removeChild(div)
    div = null
    return isSupport
  },
  /**
   * 转换时间格式
   * 用法：format(ms,'yyyy-MM-dd hh:mm:ss')
   * @param time 毫秒数
   * @param fmt 要转换的时间格式
   */
  format: function (time, fmt) {
    const d = new Date(time)
    const o = {
      'M+': d.getMonth() + 1, // 月份
      'd+': d.getDate(), // 日
      'h+': d.getHours(), // 小时
      'm+': d.getMinutes(), // 分
      's+': d.getSeconds(), // 秒
      'q+': Math.floor((d.getMonth() + 3) / 3), // 季度
      S: d.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (`${d.getFullYear()}`).substr(4 - RegExp.$1.length)) }
    for (const k in o) { 
      if (new RegExp(`(${k})`).test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length))) } 
    }
    return fmt
  },
  /**
   * 格式化倒计时
   * @param time 时间戳
   * return [[0,0], [0,0], [0,0], [1]]
   */
  formatCountDown: function (time) {
    var h = 0, m = 0, s = 0, ms = 0;
    if (time >= 0) {
      h = Math.floor(time / 1000 / 60 / 60);
      m = Math.floor(time / 1000 / 60 % 60);
      s = Math.floor(time / 1000 % 60);
      ms = Math.floor(time % 1000);
    }
    h = this.parseDate(h).toString().split('');
    m = this.parseDate(m).toString().split('');
    s = this.parseDate(s).toString().split('');
    ms = [Math.floor(ms/100)]
    return {
      h: h,
      m: m,
      s: s,
      ms: ms
    }
  },
  /**
   * 转换时间格式(兼容ios浏览器)
   * 用法：format(ms,'yyyy-MM-dd hh:mm:ss')
   * @param time 毫秒数
   * @param fmt 要转换的时间格式
   */
  formatNew: function (time, fmt) {
    if (typeof time === 'string' && time.constructor == String) {
      time = time.toString().replace(/-/g, '/')
    }
    const d = new Date(time)
    const o = {
      'M+': d.getMonth() + 1, // 月份
      'd+': d.getDate(), // 日
      'h+': d.getHours(), // 小时
      'm+': d.getMinutes(), // 分
      's+': d.getSeconds(), // 秒
      'q+': Math.floor((d.getMonth() + 3) / 3), // 季度
      S: d.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (`${d.getFullYear()}`).substr(4 - RegExp.$1.length)) }
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length))) } 
    }
    return fmt
  },
  // 传入时间是否是今天
  timeIsToday: function (time) {
    const d = new Date(Date.now() + 24 * 60 * 60 * 1000 + 8 * 3600 * 1000)
    return time < new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 0, 0, 0, 0).getTime()
  },
  // 传入时间是否是明天
  timeIsTomorrow: function (time) {
    const d = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000 + 8 * 3600 * 1000)
    return time < new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 0, 0, 0, 0).getTime()
  },
  /**
   * 将小于10的数字前加一个0
   * @param t 需要转换的数字
   * @returns 返回转换过的数字
   */
  parseDate: function (t) {
    return t < 10 ? `0${t}` : t
  },
  /**
   * 设置某个缓存
   * @param key 缓存名称
   * @param value 缓存值
   */
  setStorage: function (key, value) {
    key = key.replace(/\//g, '_')
    if (value === undefined) return
    localStorage.setItem(key, JSON.stringify(value))
  },
  /**
   * 获取某个缓存
   * @param key 通过缓存名称
   */
  getStorage: function (key) {
    key = key.replace(/\//g, '_')
    return JSON.parse(localStorage.getItem(key))
  },
  /**
   * 清除某个缓存
   * @param key 通过缓存名称
   */
  removeStorage: function (key) {
    key = key.replace(/\//g, '_')
    localStorage.removeItem(key)
  },
  /**
   * 清除所有缓存
   */
  clearStorage: function () {
    localStorage.clear()
  },

  /**
   * 设置session某个缓存
   * @param key 缓存名称
   * @param value 缓存值
   */
  setSessionStorage: function (key, value) {
    key = key.replace(/\//g, '_')
    if (value === undefined) return
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  /**
   * 获取session某个缓存
   * @param key 通过缓存名称
   */
  getSessionStorage: function (key) {
    key = key.replace(/\//g, '_')
    return JSON.parse(sessionStorage.getItem(key))
  },
  /**
   * 清除session某个缓存
   * @param key 通过缓存名称
   */
  removeSessionStorage: function (key) {
    key = key.replace(/\//g, '_')
    sessionStorage.removeItem(key)
  },
  /**
   * 清除session所有缓存
   */
  clearSessionStorage: function () {
    sessionStorage.clear()
  },
  /**
   * 设置页面标题
   */
  setDocumentTitle: function (title) {
    setTimeout(() => {
      // 利用iframe的onload事件刷新页面
      document.title = title
      const iframe = document.createElement('iframe')
      iframe.src = '//static.yunjiweidian.com/qnUpload/frontend/logo/favicon.ico' // 必须
      iframe.style.visibility = 'hidden'
      iframe.style.width = '1px'
      iframe.style.height = '1px'
      iframe.onload = function () {
        setTimeout(() => {
          document.body.removeChild(iframe)
        }, 0)
      }
      document.body.appendChild(iframe)
    }, 0)
  },
  /**
   * 将年月日转换成时间戳的形式
   * eg：将2017-03-28转换成1490630400000
   * @param str 日期的字符串
   * return times 时间戳
   */
  getDateTimes(str) {
    var str = str.replace(/-/g, '/') // 将-替换成/，因为下面这个构造函数只支持/分隔的日期字符串
    const date = new Date(str) // 构造一个日期型数据，值为传入的字符串
    const times = date.getTime()
    return times
  },
  /**
   * 将当前的年月日转换成时间戳的形式
   */
  getCurrDateTimes() {
    const date = new Date()
    let month = date.getMonth() + 1
    let strDate = date.getDate()
    if (month >= 1 && month <= 9) {
      month = `0${month}`
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = `0${strDate}`
    }
    const currentDate = `${date.getFullYear()}-${month}-${strDate} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
    return YunJi.getDateTimes(currentDate)
  },
  /**
   * 截取字符串
   * @param str 需要截取的字符串
   * @param len 截取的长度
   * return str 截取后的字符串
   */
  cutStr(str, len) {
    let str_length = 0
    let str_len = 0
    let str_cut = new String()
    str_len = str.length
    for (let i = 0; i < str_len; i++) {
      const a = str.charAt(i)
      str_length++
      if (escape(a).length > 4) {
        // 中文字符的长度经编码之后大于4
        str_length++
      }
      str_cut = str_cut.concat(a)
      if (str_length > len) {
        str_cut = str_cut.substring(0, str_cut.length - 1).concat('...')
        return str_cut
      }
    }
    // 如果给定字符串小于等于指定长度，则返回源字符串；
    if (str_length <= len) {
      return str
    }
  },
  /**
   * 是否是微信浏览器，true代表是微信浏览器
   */
  isWeiXin() {
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true
    } 
    return false
  },
  /**
   * 是否是app，true代表是app版本
   */
  isApp() {
    const appCont = YunJi.getUrlParams('appCont') || 0// H5、app
    const isNewVersion = YunJi.getUrlParams('isNewVersion') || 0 // 专题
    if (appCont == 1 || appCont == 2 || isNewVersion == 1) {
      return true
    } 
    return false
  },
  showNavBar() {
    const rs = YunJi.getUrlParams('hideNavBar') || 'false'// H5、app
    if (rs == 'true' && YunJi.isApp()) {
      return true
    } 
    return false
  },
  /**
   * 是否是QQ，true代表是QQ
   */
  isQQ() {
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/QQ/i) == 'qq') { // 在QQ打开
      return true
    } 
    return false
  },
  /**
   * 获取cookie的函数
   */
  getCookie(cookieName) {
    const strCookie = document.cookie
    const arrCookie = strCookie.split('; ')
    for (let i = 0; i < arrCookie.length; i++) {
      const arr = arrCookie[i].split('=')
      if (cookieName == arr[0]) {
        return arr[1]
      }
    }
    return ''
  },
  /**
   * 设置用户登录的cookie，只有非微信浏览器
   * qq、微博浏览器，或者其他浏览器登录成功才存在此cookie信息
   */
  setJPCookie(cname, cvalue, exdays) {
    const d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    const str = `${window.location.host.split('.')[1]}.${window.location.host.split('.')[2]}`
    document.cookie = `${cname}=${escape(cvalue)};expires=${d.toGMTString()};path=/;domain=${str};`
  },
  /**
   * 清除用户登录的cookie，只有非微信浏览器
   * qq、微博浏览器，或者其他浏览器登录成功才存在此cookie信息
   */
  clearJPCookie(cname) {
    YunJi.setJPCookie(cname, '', -1)
  },
  /**
   * 获得角度
   */
  getAngle(angx, angy) {
    return Math.atan2(angy, angx) * 180 / Math.PI
  },
  /**
   * 根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
   */
  getDirection(startx, starty, endx, endy) {
    const angx = endx - startx
    const angy = endy - starty
    let result = 0
    // 如果滑动距离太短
    if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
      return result
    }
    const angle = YunJi.getAngle(angx, angy)
    if (angle >= -135 && angle <= -45) {
      result = 1
    } else if (angle > 45 && angle < 135) {
      result = 2
    } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
      result = 3
    } else if (angle >= -45 && angle <= 45) {
      result = 4
    }
    return result
  },
  /**
   * 是qq浏览器，才增加此方法，在qq浏览器中，页面滑动很容易触发点击事件
   * @dom 需要屏蔽点击事件的dom
   */
  setQQClickFunction(dom) {
    if (YunJi.isQQ()) {
      let startx, 
        starty
      // 手指接触屏幕 - 屏蔽点击事件
      document.addEventListener('touchstart', (e) => {
        startx = e.touches[0].pageX
        starty = e.touches[0].pageY
        $(dom).addClass('event-none')
      }, false)
      // 手指离开屏幕
      document.addEventListener('touchend', (e) => {
        let endx, 
          endy
        endx = e.changedTouches[0].pageX
        endy = e.changedTouches[0].pageY
        const direction = YunJi.getDirection(startx, starty, endx, endy)
        switch (direction) {
          case 0: // 未滑动 - 开启点击事件
            $(dom).removeClass('event-none')
            break
          default:
            break
        }
      }, false)
    }
  },
  /**
   * 下拉页面滑动很容易触发点击事件
   * @dom 需要屏蔽点击事件的dom
   */
  setClickFunction(dom) {
    let startx, 
      starty
    // 手指接触屏幕 - 屏蔽点击事件
    document.addEventListener('touchstart', (e) => {
      startx = e.touches[0].pageX
      starty = e.touches[0].pageY
      $(dom).addClass('event-none')
    }, false)
    // 手指离开屏幕
    document.addEventListener('touchend', (e) => {
      let endx, 
        endy
      endx = e.changedTouches[0].pageX
      endy = e.changedTouches[0].pageY
      const direction = YunJi.getDirection(startx, starty, endx, endy)
      switch (direction) {
        case 0: // 未滑动 - 开启点击事件
          $(dom).removeClass('event-none')
          break
        default:
          break
      }
    }, false)
  },
  /**
   * 客户端版本检测
   * @params version 最新版本信息对象
   * 例：version = {
     *          appCont：1, //Number
     *          android：{
     *               seller: '3.66.0811', //String
     *               vip:    '2.0.0811'  //String
     *          },
     *          ios:{
     *               seller: '3.66.0811', //String
     *               vip:    '2.0.0811'  //String
     *          }
     *     }
   * @return
   */
  isNewVersion(version) {
    let isNewVersion = false// 是否客户端新版本
    switch (version.appCont) {
      case 0:
        isNewVersion = false
        break
      case 1: // 卖家版
        if (YunJi.appUA.appVersion > version.ios.seller && YunJi.appUA.appClient == 'ios' || YunJi.appUA.appVersion > version.android.seller && YunJi.appUA.appClient == 'android') {
          isNewVersion = true
        } else {
          isNewVersion = false
        }
        break
      case 2: // 买家版
        if (YunJi.appUA.appVersion > version.ios.vip && YunJi.appUA.appClient == 'ios' || YunJi.appUA.appVersion > version.android.vip && YunJi.appUA.appClient == 'android') {
          isNewVersion = true
        } else {
          isNewVersion = false
        }
        break
    }
    return isNewVersion
  },
  /**
   * 加载腾讯视频
   * 需要在页面引入腾讯视频 tvp.player.js
   * @params vid 腾讯视频vid
   * @params width  视频显示高度
   * @params height 视频显示宽度
   * @params auto   视频是否自动播放
   *
   */
  setTencentVideo(videoInfo) {
    const video = new tvp.VideoInfo()// 定义视频对象
    video.setVid(videoInfo.vid)// 向视频对象传入视频vid
    const player = new tvp.Player(videoInfo.width, videoInfo.height)// 定义播放器对象
    player.setCurVideo(video)// 设置播放器初始化时加载的视频
    player.addParam('flashskin', `${window.location.protocol}//imgcache.qq.com/minivideo_v1/vd/res/skins/TencentPlayerMiniSkin.swf`)// 设置精简皮肤，仅点播有效
    player.addParam('autoplay', videoInfo.auto || true)// 是否自动播放
    player.addParam('wmode', 'window')// 默认情况下，视频处为最高级，总是处于页面的最上层，应当设置其透明
    player.addParam('showend', 0)// 结束画面是否有广告画面，或者是该视频本身结束
    player.addParam('preload', true)
    player.write('tencent-video')// 输出播放器,参数是输出dom的id
  },
  // 是否跨境商品
  isCrossBorder(itemChannel) {
    if (itemChannel == 3 || itemChannel == 4 || itemChannel == 5 || itemChannel == 6 || itemChannel == 7 || itemChannel == 8 || itemChannel == 9 || itemChannel == 10 || itemChannel == 11 || itemChannel == 12 || itemChannel == 13) {
      return true
    } 
    return false
  },
  /**
   * 判断对象是否为空
   */
  isEmptyObj(obj) {
    if (JSON.stringify(obj) == '{}' || obj == '{}') {
      return true
    } 
    return false
  },
  /**
   * 增加盲人模式下的，弹窗提示
   */
  addRoleAlert() {
    $('.mint-msgbox').attr('role', 'alert')
  },
  /**
   * 获取购物车数量
   */
  getCartCount() {
    let cartNum = 0
    if (currentAjax != null || currentAjax) { // 如若上一次AJAX请求未完成，则终止请求
      currentAjax.abort()
    }
    if (globalConfig.testMode == 'yes' && (parseInt(this.getUrlParams('appCont')) == 0 || parseInt(this.getUrlParams('appCont')) == 3)) {
      // 获取cookie相关信息设置
      $.ajaxSetup({
        xhrFields: {
          withCredentials: true
        }
      })
    }
    currentAjax = $.ajax({
      async: false,
      url: `//${globalConfig.linkBasePath}/yunjibuyer/cart/itemCount.json`,
      type: 'GET',
      dataType: 'json',
      data: {
        cuid: YunJi.getStorage('cuid') != undefined ? YunJi.getStorage('cuid').id : '',
        shopId: this.getUrlParams('shopId'),
        appCont: this.getUrlParams('appCont') || 0 // 是否app
      },
      success: (result) => {
        YunJi.setStorage('cuid', { id: result.cuid })
        if (result.errorCode == 0) {
          cartNum = result.data !== null && result.data != '' ? result.data : 0
        } else {
          cartNum = 0
        }
      },
      error: () => {
        cartNum = 0
      }
    })
    // this.setCartCookie(cartNum);
    YunJi.setStorage('CART_COUNT', { num: cartNum })
    return cartNum
  },
  // 设置购物车请求总数的cookie
  setCartCookie(cartNum) {
    const d = new Date()
    d.setTime(d.getTime() + (5 * 1000))
    const str = `${window.location.host.split('.')[1]}.${window.location.host.split('.')[2]}`
    const userCookies = document.cookie
    if (userCookies == '' || userCookies === null || typeof (userCookies) === 'undefined') {
      document.cookie = `CART_COUNT=${cartNum};expires=${d.toGMTString()};path=/;domain=${str};`
    } else if (userCookies.indexOf('CART_COUNT') == -1) {
      document.cookie = `CART_COUNT=${cartNum};expires=${d.toGMTString()};path=/;domain=${str};`
    }
  },
  // 获取购物车缓存
  getCartCookie() {
    const name = 'CART_COUNT'
    const arr = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)(;|$)`))
    if (arr != null) return unescape(arr[2]); return null
  },
  // 清除cookie
  clearCookie() {
    const str = `${window.location.host.split('.')[1]}.${window.location.host.split('.')[2]}`
    document.cookie = `CART_COUNT=null;expires=-1;path=/;domain=${str};`
  },
  // 节流函数
  throttle(fn, delay) {
    // now:当前的时间; lastExec:上次执行的时间; timer: 记录timeout的id; context: fn执行的上下文作用域；args:函数执行传递的参数
    let now, 
      lastExec, 
      timer, 
      context, 
      args
    // scroll回调函数真正执行的核心函数
    const execute = function () {
      fn.apply(context, args)
      lastExec = now
    }
    // 闭包函数(绑定到scroll事件上的回调函数)
    return function () {
      context = this
      args = arguments
      now = Date.now()
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      if (lastExec) {
        // 判断是否超过指定时间间隔，超过则执行
        const diff = delay - (now - lastExec)
        if (diff < 0) {
          execute()
        } else {
          timer = setTimeout(() => {
            execute()
          }, diff)
        }
      } else {
        execute()
      }
    }
  },
  // 防抖函数
  debounce(fn, delay, mustRunDelay) {
    let timer = null
    let t_start
    return function () {
      const context = this
      const args = arguments
      const t_curr = +new Date()
      clearTimeout(timer)
      if (!t_start) {
        t_start = t_curr
      }
      if (t_curr - t_start >= mustRunDelay) {
        fn.apply(context, args)
        t_start = t_curr
      } else {
        timer = setTimeout(() => {
          fn.apply(context, args)
        }, delay)
      }
    }
  },
  /**
   * 是否是ipx系列手机
   */
  isIphoneX() {
    // iPhone X、iPhone XS
    const isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.screen.width === 375 && window.screen.height === 812
    // iPhone XS Max
    const isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.screen.width === 414 && window.screen.height === 896
    // iPhone XR
    const isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.screen.width === 414 && window.screen.height === 896
    if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
      return true
    }
    return false
  },
  /**
   * 调用app内部方法
   * eg:appCommonRule('20181224','reportLoadingCompletedJs',['1','2'])
   * 版本号日期，方法名，数组格式的参数
   * @param callback 回调传入app方法返回的值
   */
  appCommonRule(appIdForH5, methodName, value, callback) {
    const appCont = YunJi.getUrlParams('appCont') || 0
    let backValue
    if ((parseInt(appCont) == 1 || parseInt(appCont) == 2) && YunJi.appUA && YunJi.appUA.appIdForH5 >= appIdForH5) {
      if (typeof (yjapp) !== 'undefined' && typeof yjapp[methodName] === 'function') {
        if (value == undefined) {
          backValue = new Function(`return yjapp.${methodName}()`)()
        } else {
          // backValue=eval("yjapp."+methodName+"("+value+")")
          backValue = new Function('value', `return yjapp.${methodName}(value)`)(value)
        }
        backValue && callback && callback(backValue)
      } else if (!YunJi.getPhoneType()) {
        YunJi.appRule(methodName, value)
      }
    }
  },

  /**
   * 新的调用app内部方法 iOS内核优化后版本
   * eg:newAppCommonRule('20181224','reportLoadingCompletedJs',{params:params,fun:'fun'})
   * window.webkit.messageHandlers.methodName.postMessage({a:1,b:2,func:''})
   * @param callback 回调传入app方法返回的值
   */
  newAppCommonRule(appIdForH5, methodName, value) {
    const appCont = YunJi.getUrlParams('appCont') || 0
    if ((parseInt(appCont) == 1 || parseInt(appCont) == 2) && YunJi.appUA && YunJi.appUA.appIdForH5 >= appIdForH5) {
      if (JSON.stringify(value) == '{}' || value == undefined || value == '') {
        try {
          window.webkit.messageHandlers[methodName].postMessage(null)
        } catch (e) {
          // console.log(e)
        }
      } else {
        try {
          window.webkit.messageHandlers[methodName].postMessage(value)
        } catch (e) {
          // console.log(e)
        }
      }
    }
  },
  /**
 * 新版的app调用方法 统一参数格式
 * eg:appCommonRules('20181224','reportLoadingCompletedJs',{a:2})
 * 版本号日期，方法名，参数
 * @param appIdForH5 对应的版本号
 * @param methodName app方法名称
 * @param value app方法接收的参数
 */
  appCommonRules(appIdForH5, methodName, value) {
    const appCont = YunJi.getUrlParams('appCont') || 0
    if ((parseInt(appCont, 10) === 1 || parseInt(appCont, 10) === 2) && YunJi.appUA && YunJi.appUA.appIdForH5 >= appIdForH5) {
      if (YunJi.appUA.appIdForH5 >= '20190419' && YunJi.appUA.appClient == 'ios' && YunJi.appUA.useWkWeb == 1) {
        // ios 新wk内核
        if (!value || JSON.stringify(value) === '{}' || value === '{}') {
          try { window.webkit.messageHandlers[methodName].postMessage(null) } catch (e) {}
        } else {
          try { window.webkit.messageHandlers[methodName].postMessage(value) } catch (e) {}
        }
      } else if (typeof (yjapp) !== 'undefined' && typeof yjapp[methodName] === 'function') {
        if (value === undefined) {
          yjapp[methodName]()
        } else if (Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]') {
          yjapp[methodName](JSON.stringify(value))
        } else {
          yjapp[methodName](value)
        }
      } else if(YunJi.appUA.appClient == 'android') {
        // 安卓旧规则
        prompt(JSON.stringify({ methodName, value }))
      }
    }
  },
  /**
  * app的Android低版本手机规则调用
  * eg:appRule('reportLoadingCompletedJs',['1','2'])
  * {methodName:'reportLoadingCompletedJs',value:['1','2']}
  */
  appRule(methodName, value) {
    prompt(`{methodName:${methodName},value:${value}}`)
  },
  /**
  * 调起H5登录页
  */
  callH5LoginPage() {
    const backUrl = window.location.href
    const shopId = YunJi.getUrlParams('shopId')
    location.href = `//${globalConfig.buyerBasePath}/yjbuyer/login?shopId=${shopId}&backUrl=${escape(backUrl)}`
  },
  /**
  * app生命周期监听，20190123版本增加
  */
  appLifeMonitor() {
    window.onStart = this.onStart.bind(this)
    window.onStop = this.onStop.bind(this)
  },
  /**
   * 资源位产出值上报
   */
  resourceStorage() {
    if (YunJi.getUrlParams('RSid')) {
      const resourceStateDate = { // 源位产出后端记录
        resource_state_id: YunJi.getUrlParams('RSid'), // 预设资源位id
        business_id: YunJi.getUrlParams('Bid') // 业务ID
      }
      if (YunJi.getUrlParams('Ctype')) { // 内容类型
        resourceStateDate.content_type = YunJi.getUrlParams('Ctype')
      }
      if (YunJi.getUrlParams('Cid')) { // 内容id
        resourceStateDate.content_id = YunJi.getUrlParams('Cid')
      }
      if (YunJi.getUrlParams('ATid')) { // 活动场次id
        resourceStateDate.activity_time_id = YunJi.getUrlParams('ATid')
      }
      return resourceStateDate
    } // 当本次进入没有资源位,有上一次的资源位缓存时,清除上一次的资源位数据
    return YunJi.removeStorage('resourceState')
  },
  /**
   * url 目标url
   * arg 需要替换的参数 名称
   * arg_val 替换后的参数的值
   * return url 参数替换后的url
   */
  changeURLArg(url, arg, arg_val) {
    const pattern = `${arg}=([^&]*)`
    const replaceText = `${arg}=${arg_val}`
    if (url.match(pattern)) {
      let tmp = `/(${arg}=)([^&]*)/gi`
      tmp = url.replace(eval(tmp), replaceText)
      return tmp
    }
    if (url.match('[\?]')) {
      return `${url}&${replaceText}`
    }
    return `${url}?${replaceText}`
      
    
  },
  /** 获取打标数组顺序* */
  getMarkConfig() {
    const params = {}
    AJAX('/yunjibuyer/global/queryByUrlPath.json', {
      params: params
    }).then((res) => {
      if (res.errorCode == 0 && res.data) {
        if (res.errorCode == 0 && res.data) {
          YunJi.markOrderArray = res.data.itemMarkPriorityForHeart.split(',')     
        }
      }
    }).catch((res) => {
      
    })

    // todo
    // $.ajax({
    //   url:"//" +globalConfig.linkBasePath + "/yunjibuyer/global/queryByUrlPath.json",
    //   type: "GET",
    //   dataType: "json",
    //   success: res => {
    //     if (res.errorCode == 0 && res.data) {
    //       YunJi.markOrderArray = res.data.itemMarkPriorityForHeart.split(",");     
    //     }
    //   },
    //   error: () => {}
    // });
  },
  /**
   * url 目标url
   * arg 需要替换的参数名称
   * arg_val 替换后的参数的值
   * return url 参数替换后的url
   */
  changeURLArg(url, arg, arg_val) {
    var pattern = arg + '=([^&]*)';
    var replaceText = arg + '=' + arg_val;
    if (url.match(pattern)) {
      var tmp = '/(' + arg + '=)([^&]*)/gi';
      tmp = url.replace(eval(tmp), replaceText);
      return tmp;
    } else {
      if (url.match('[\?]')) {
        return url + '&' + replaceText;
      } else {
        return url + '?' + replaceText;
      }
    }
  },
  getConsumerId() {
    return (
      YunJi.appUA.consumerId ||
      window.localStorage.getItem("consumerId") ||
      (/^(\d+);?$/.exec(this.getCookie("burial_point_cid")) || [])[1] ||
      ""
    )
  },
  callApp(methodsName, data, options) { // app交互 jsCallNativePageScroll 当前是否在滚动
    if (!YunJi.isApp()) return
    try {
      const core = options && options.coreName || 'yjapp'
      const androidApp = typeof (window[core]) !== 'undefined' && typeof window[core][methodsName] === 'function'
      const iosApp = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[methodsName]
      const hasFail = options && options.fail && typeof options.fail === 'function'
      if (!androidApp && !iosApp && hasFail) { // 表示当前没找到对应方法
        console.log(`触发：${methodsName} ，参数：${data}，错误：未找到对应方法`)
        options.fail()
        return
      }
      if (androidApp) { // 与安卓app通讯方式
        window[core][methodsName](data)
      } else if (iosApp) { // 与iOS app通讯方式
        window.webkit.messageHandlers[methodsName].postMessage(data)
      }
      console.log(`触发：${methodsName} ，参数：${data}`)
    } catch (error) {
      console.log(`触发：${methodsName} ，参数：${data}，错误：${error}`)
    }
  },
}

export default YunJi = new YunJi()

if (YunJi.getPhoneType()) {
  const _sort = Array.prototype.sort
  Array.prototype.sort = function (fn) {
    if (!!fn && typeof fn === 'function') {
      if (this.length < 2) return this
      let i = 0, 
        j = i + 1, 
        l = this.length, 
        tmp, 
        r = false, 
        t = 0
      for (; i < l; i++) {
        for (j = i + 1; j < l; j++) {
          t = fn.call(this, this[i], this[j])
          r = (typeof t === 'number' ? t : t ? 1 : 0) > 0
          if (r) {
            tmp = this[i]
            this[i] = this[j]
            this[j] = tmp
          }
        }
      }
      return this
    } 
    return _sort.call(this)
  }
}
